export default "__VITE_ASSET__9dm8hZfs__"